import React from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";

class About extends React.Component {
  /*Scroll to top of page at init*/
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>RPGONE Translations</title>
          <meta name="title" content="About RPGONE Translations" />
          <meta name="description" content="About RPGONE Translations" />
        </Helmet>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <span className="title-centered">
                <i>
                  <div />
                </i>
              </span>
              <div className="center-image">
                <img
                  src={require("./img/banner.gif")}
                  alt=""
                  className="imageResize"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <span className="title-centered">
                <h3>Projects</h3>
                <i>
                  <div />
                </i>
              </span>
              <br />
              <b>Group Projects</b>
              <br />
              <img
                src={require("./img/about/Neugier.png")}
                alt=""
                className="imageResize"
              />
              <img
                src={require("./img/about/Slayers.png")}
                alt=""
                className="imageResize"
              />
              <img
                src={require("./img/about/Wozz.png")}
                alt=""
                className="imageResize"
              />
              <br />
              <br />
              <b>ChrisRPG</b>
              <br />
              <img
                src={require("./img/about/Dragon Quest 1&2.png")}
                alt=""
                className="imageResize"
              />
              <img
                src={require("./img/about/Final Fantasy 3.png")}
                alt=""
                className="imageResize"
              />
              <img
                src={require("./img/about/Super Gussun Oyoyo 2.png")}
                alt=""
                className="imageResize"
              />
              <br />
              <br />

              <b>Jonny</b>
              <br />
              <img
                src={require("./img/proj/ace_00001.png")}
                alt=""
                className="imageResize"
              />
              <img
                src={require("./img/doremi00002_title.png")}
                alt=""
                className="imageResize"
              />
              <img
                src={require("./img/proj/koryu_00000.png")}
                alt=""
                className="imageResize"
              />
              <img
                src={require("./img/mickey3_english_1.png")}
                alt=""
                className="imageResize"
              />
              <img
                src={require("./img/proj/miracle1.png")}
                alt=""
                className="imageResize"
              />
              <img
                src={require("./img/proj/undercover_00000.png")}
                alt=""
                className="imageResize"
              />
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(About);



// WEBPACK FOOTER //
// ./src/About.js